import React from 'react';
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import './Solutions.css';
import camion1 from "../pictures/imagecam11.JPG";
import camion2 from "../pictures/imagecam7.jpeg";
import camion3 from "../pictures/imagecam3.jpeg";
import camion4 from "../pictures/fourchette.png";

const Solutions = () => (
  <>
    <Navbar />
    <Hero />
    <section className="solutions-offered" id="solutions">
        <h2>NOS SERVICES</h2>
        <p className="section-description">
          Découvrez notre gamme complète de services de transport et de location, conçue pour répondre à vos besoins avec excellence et précision.
        </p>
      <div className="solutions-content">
        <div className="solution-category">
          <h3>Transport par Camions Lourds</h3>
          <ul className="solution-list">
            <li>
              <h4>Transport de Matériaux de Construction</h4>
              <p>
                Livraison fiable et ponctuelle de briques, blocs, poutres, acier, bois et autres matériaux de construction directement sur vos chantiers grâce à notre flotte de camions plateaux modernes, équipés pour des charges variées.
              </p>
              <img
                src={camion1}
                alt="Transport de Matériaux de Construction"
                className="solution-image"
              />
              <div className="solution-details">
                <p><strong>Capacité :</strong> Jusqu'à 30 tonnes</p>
                <p><strong>Délais :</strong> Livraison en 24-48h selon la région</p>
                <p><strong>Sécurité :</strong> Véhicules conformes aux normes ISO</p>
              </div>
            </li>
            <li>
              <h4>Transport Spécial</h4>
              <p>
                Solutions sur mesure pour le transport de charges surdimensionnées, machines industrielles et équipements lourds avec des camions semi-grues spécialisés et des chauffeurs expérimentés.
              </p>
              <img
                src={camion2}
                alt="Transport Spécial"
                className="solution-image"
              />
              <div className="solution-details">
                <p><strong>Équipements :</strong> Grues intégrées jusqu'à 50 tonnes</p>
                <p><strong>Expertise :</strong> Planification logistique personnalisée</p>
                <p><strong>Permis :</strong> Gestion des autorisations spéciales</p>
              </div>
            </li>
          </ul>
        </div>
        <div className="solution-category">
          <h3>Solutions de Location</h3>
          <ul className="solution-list">
            <li>
              <h4>Location de Camions</h4>
              <p>
                Louez des camions adaptés à vos besoins, allant des camions plateaux aux véhicules spécialisés, pour des durées flexibles, avec maintenance incluse.
              </p>
              <img
                src={camion3}
                alt="Location de Camions"
                className="solution-image"
              />
              <div className="solution-details">
                <p><strong>Options :</strong> Camions de 5 à 30 tonnes</p>
                <p><strong>Durée :</strong> Journalière, hebdomadaire ou mensuelle</p>
                <p><strong>Support :</strong> Assistance 24/7</p>
              </div>
            </li>
            <li>
              <h4>Location d'Équipements</h4>
              <p>
                Accédez à une gamme de grues, chariots élévateurs, nacelles et autres équipements de manutention pour optimiser vos opérations sur chantier.
              </p>
              <img
                src={camion4}
                alt="Location d'Équipements"
                className="solution-image"
              />
              <div className="solution-details">
                <p><strong>Équipements :</strong> Grues de 10 à 100 tonnes</p>
                <p><strong>Chariots :</strong> Capacité jusqu'à 5 tonnes</p>
                <p><strong>Formation :</strong> Instructions incluses</p>
              </div>
            </li>
          </ul>
        </div>
        <div className="solution-category">
          <h3>Services Complémentaires</h3>
          <ul className="solution-list">
            <li>
              <h4>Logistique Personnalisée</h4>
              <p>
                Planification et gestion de projets logistiques complexes, incluant l'optimisation des itinéraires et la coordination multi-chantiers.
              </p>
              <div className="solution-details">
                <p><strong>Planification :</strong> Solutions sur mesure</p>
                <p><strong>Suivi :</strong> Suivi en temps réel</p>
                <p><strong>Consultation :</strong> Experts logistiques dédiés</p>
              </div>
            </li>
            <li>
              <h4>Entretien et Support</h4>
              <p>
                Services d'entretien préventif et d'assistance technique pour garantir la performance optimale de vos équipements loués.
              </p>
              <div className="solution-details">
                <p><strong>Maintenance :</strong> Contrôles réguliers</p>
                <p><strong>Support :</strong> Hotline technique 24/7</p>
                <p><strong>Réparations :</strong> Service rapide sur site</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <Footer />
  </>
);

export default Solutions;